import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Breadcrumb, Spin, Table, Switch } from "antd";
import "./sales_browser.css";
import { useSalesBrowser, DataType } from "../../components/hoc_sales_browser";

const SalesBrowser: React.FC = () => {
    const {
        columns,
        tableData,
        handleEdit,
        isLoading,
        error,
        showAllWarehouse,
        setShowAllWarehouse,
        userData
    } = useSalesBrowser();


    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    if (isLoading) {
        return <Spin tip="Loading sales data..." size="large" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }} />;
    }
    if (error) {
        return <Alert message="Error loading sales data" description={error.message} type="error" showIcon />;
    }
    if (!tableData) {
        return null;
    }

    return (
        <div id="iau9" style={transformStyle}>
            {/* Grid Row 1 */}
            <div className="gjs-grid-row" id="ibl67">
                <div className="gjs-grid-column" id="imk6l">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: (
                                    <>
                                        <span style={{ fontWeight: '200', color: 'rgba(0, 0, 0, 0.88)' }}>Data Sales Master</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/sales_estimation",
                                title: "Sales Master",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="ig7ih">
                <div className="gjs-grid-column" id="i09xg">
                    {userData?.otoritas && String(userData.otoritas).split(';').includes('77') && ( 
                        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}> 
                            <Switch checked={showAllWarehouse} onChange={setShowAllWarehouse} /> 
                            <span style={{ fontSize: '14px' }}>Show All Warehouse</span> 
                        </div> 
                    )}
                    <Table<DataType>
                        columns={columns}
                        dataSource={tableData}
                        onRow={(record) => ({
                            onDoubleClick: () => handleEdit(record),
                        })}
                        loading={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default SalesBrowser;